import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        user: '='
    },
    template: `
        <div class="well color01">
            <h2>{{ 'user.Training needs' | translate }}</h2>
            <pagination-tools custom-options="[5,10]" list="vm.list"></pagination-tools>
            <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
            <div class="tablewrapper" ng-if="vm.list.items.length">
                <table class="data01"
                    ng-if="!vm.list.loading && vm.list.items.length"
                    datatable dt-options="vm.DATATABLES">
                    <thead>
                        <tr>
                            <th>{{ 'user.Course' | translate }}</th>
                            <th>{{ 'user.Previous date complete' | translate }}</th>
                            <th>{{ 'user.Personal deadline' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr ng-repeat="item in vm.list.items">
                            <td>
                                <a
                                    ng-if="vm.PrivilegeService.canManageCourses()"
                                    ui-sref="authorized.courses.courses.edit.occurrence.list({id: item.courseId})"
                                >
                                    {{ item.name }}
                                </a>
                                <span ng-if="!vm.PrivilegeService.canManageCourses()">{{ item.name }}</span>
                                <span ng-if="item.isInStartedApg" class="badge" uib-tooltip="{{ vm.automatedToolTip }}">A</span>
                            </td>
                            <td>
                                <span ng-if="item.previousPassedTime">{{ vm.MomentService.formatDate(item.previousPassedTime) }}</span>
                                <span ng-if="!item.previousPassedTime">-</span>
                            </td>
                            <td ng-bind-html="item.deadline | personalDeadline: item.previousPassedTime:item.isInfiniteDeadline"></td>
                        </tr>
                    </tbody>
                </table>
                <pagination list="vm.list"></pagination>
            </div>
        </div>
    `
})
export default class {
    constructor ($translate, UserResource, TokenService, MomentService, PrivilegeService, ListFactory, DATATABLES) {
        this.$translate = $translate;
        this.UserResource = UserResource;
        this.TokenService = TokenService;
        this.MomentService = MomentService;
        this.PrivilegeService = PrivilegeService;
        this.DATATABLES = DATATABLES;
        this.list = ListFactory.createWithPagination(UserResource.trainingNeedUserCourses.bind(UserResource));
    }

    $onInit () {
        this.filter = {
            id: this.user.id,
            isPlanningSearch: false,
            isAdvancedSearch: true,
            pageSize: 5
        };
        this.list.sort = 'deadline';
        this.list.fetch(this.filter);

        this.automatedToolTip = this.$translate.instant('user.Added to automated planning group');
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/employee/detail/trainingNeeds/index.js